// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9a53b2f8","110":"7a0c5a57","266":"e348711c","285":"18901344","361":"3812a850","409":"767d9a29","453":"3139f9ad","497":"06df5342","670":"ba8f816a","848":"394a92ed","879":"aebab65e"}[chunkId] + ".chunk.js";
};